import Sortable from 'sortablejs';

const realpressAdditionalFields = () => {
	const addElNodes = document.querySelectorAll( '.realpress-additional-fields' );
	for ( let i = 0; i < addElNodes.length; i++ ) {
		const addElNode = addElNodes[ i ];
		const trTempNode = addElNode.querySelector( 'tbody tr.realpress-additional-item-template' );
		let trNodes = addElNode.querySelectorAll( 'tbody tr:not(.realpress-additional-item-template)' );
		let trNumber = trNodes.length;
		trTempNode.remove();

		const handleRemove = ( field ) => {
			field.querySelector( '.realpress-remove' ).addEventListener( 'click', function() {
				field.remove();
				trNumber = trNumber - 1;
				reindexElements();
			} );
		};

		addElNode.querySelector( '.add-more' ).addEventListener( 'click', function() {
			const fieldNode = this.closest( '.realpress-additional-fields' );
			const cloneTrNode = trTempNode.cloneNode( true );
			changeAttributes( cloneTrNode );
			fieldNode.querySelector( 'tbody' ).appendChild( cloneTrNode );
			trNumber = trNumber + 1;
			handleRemove( cloneTrNode );
		} );

		//Remove value attibutes
		const changeAttributes = ( cloneTrNode ) => {
			cloneTrNode.classList.remove( 'realpress-additional-item-template' );
			cloneTrNode.querySelectorAll( 'input,select' ).forEach( function( elementNode ) {
				if ( elementNode.value ) {
					elementNode.value = '';
				}

				const attributes = [ 'name', 'id' ];
				for ( let i = 0; i < attributes.length; i++ ) {

				}
				elementNode.setAttribute( 'name', elementNode.getAttribute( 'name' ).replace( /(\d+)/, function( $el1, $el2 ) {
					if ( trNumber ) {
						return trNumber;
					}

					return 0;
				} ) );
				elementNode.setAttribute( 'id', elementNode.getAttribute( 'name' ).replace( /(\d+)/, function( $el1, $el2 ) {
					if ( trNumber ) {
						return trNumber;
					}

					return 0;
				} ) );
			} );
		};

		//Remove button
		const addFields = addElNode.querySelectorAll( '.realpress-additional-fields-table tbody tr' );
		for ( let i = 0; i < addFields.length; i++ ) {
			handleRemove( addFields[ i ] );
		}

		//Drag and drop
		const sortElement = addElNode.querySelector( 'tbody' );
		Sortable.create( sortElement, {
			handle: '.realpress-sort > span', animation: 150,
			onEnd() {
				reindexElements();
			},
		} );

		const reindexElements = () => {
			//Get update again NodeList
			trNodes = addElNode.querySelectorAll( 'tbody tr:not(.realpress-additional-item-template)' );
			trNodes.forEach( function( trNode, index ) {
				trNode.querySelectorAll( 'input,select' ).forEach( function( elementNode ) {
					elementNode.setAttribute( 'name', elementNode.getAttribute( 'name' ).replace( /(\d+)/, function( $el1, $el2 ) {
						return Number( index );
					} ) );
					elementNode.setAttribute( 'id', elementNode.getAttribute( 'name' ).replace( /(\d+)/, function( $el1, $el2 ) {
						return Number( index );
					} ) );
				} );
			} );
		};
	}
};

export default realpressAdditionalFields;
